// extracted by mini-css-extract-plugin
export default {"sections":"ContentUI_sections__U8xB4"};